import { render, staticRenderFns } from "./ExclusiveCourses.vue?vue&type=template&id=7a85cdab&scoped=true&"
import script from "./ExclusiveCourses.vue?vue&type=script&lang=js&"
export * from "./ExclusiveCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a85cdab",
  null
  
)

export default component.exports